var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_c('span',{staticClass:"ml-1"},[_vm._v("GoGuau © "+_vm._s(new Date().getFullYear())+".")])]),_c('div',{staticClass:"mfs-auto"})])
}
var staticRenderFns = []

export { render, staticRenderFns }